import { useMediaQuery } from '@passkeys/hooks';

function useIsExtendedLayout(): boolean {
  return useMediaQuery(`(min-width: ${__EXTENDED_LAYOUT_BREAKPOINT__})`);
}

export default useIsExtendedLayout;
